import React, { useMemo } from 'react';
import { SelectTypeahead } from '../../fields/SelectTypeahead';
import { SmartformElementData } from '../../types';
import { getElementFields } from '../../forms/utils/getElementFields';
import { useSmartFormContext } from '../../forms/utils/useSmartFormContext';

export const Gender: React.FC<SmartformElementData> = (props) => {
  const [gender] = getElementFields(props).required;
  const { translations } = useSmartFormContext();

  const defaultValues = useMemo(
    () => [
      { label: translations?.genderMaleLabel || 'Male', value: 'MALE' },
      { label: translations?.genderFemaleLabel || 'Female', value: 'FEMALE' },
      { label: translations?.genderOtherLabel || 'Other', value: 'OTHER' },
      { label: translations?.genderUnknownLabel || 'Unknown', value: 'UNKNOWN' }
    ],
    [translations]
  );

  const element = props.element;

  return (
    <SelectTypeahead<string>
      values={
        (element.payload?.dropdownValues?.length ? element.payload.dropdownValues : defaultValues).map(
          ({ label, value }) => ({
            id: value,
            label,
            value
          })
        ) ?? []
      }
      name={gender.name}
      key={gender.name}
      placeholder={gender.hint}
      required={gender.validation.required}
      helpText={gender.helpText}
      infoText={gender.infoText}
      label={gender.label}
      fullWidth
      initialValue={gender.initialValue}
    />
  );
};
